import React from 'react';
import core from '@gin-betting/core';
import loadable from '@loadable/component';

import { Modules } from 'async-modules';
import { Odd, OddStub } from 'components';
import ui from 'modules/ui';
import BetslipStub from './BetslipStub';

type OddProps = PropsFromReactComponent<typeof Odd>;

const {
    entities: {
        components: { makeOddContainerFor },
    },
    utils: { getBettingOptions },
} = core;
const {
    components: { OddFormat },
} = ui;

type AsyncOddButtonProps = {
    oddId: string | undefined;
    showResult?: boolean;
    withTitle?: boolean;
    fRef?: (ref: HTMLElement | null) => void;
    onMouseEnter?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    onMouseLeave?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    modifyOddTitle?: (name: string) => string;
    stubNode?: JSX.Element;
};

const OddContainer = makeOddContainerFor<OddProps>();

export const loadBetslipModule: () => Promise<
    Modules['betslip']
> = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "betslip-module" */ '../index');

export const OddButtonLoadable = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.OddButton,
});

// TODO: Add proper types for "props"
export const AsyncOddButton = (props: AsyncOddButtonProps): JSX.Element => (
    <OddButtonLoadable
        {...props}
        fallback={
            <OddFormat>
                {oddFormat => (
                    <OddContainer
                        oddId={props.oddId}
                        props={{ ...props, oddFormat }}
                        component={props.oddId ? Odd : OddStub}
                    />
                )}
            </OddFormat>
        }
    />
);

export const AsyncBetslipList = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.BetslipList,
    fallback: (
        <BetslipStub
            shouldReturnNull={getBettingOptions().url.pagePath !== ''}
            withoutPortal={typeof window === 'undefined'} // Do not try to make Portal on ssr
        />
    ),
});

export const AsyncBetslipListSubscription = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.BetslipListSubscription,
});

export const AsyncBetslipBetCount = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.BetslipBetCount,
});

export const AsyncQuickBetslip = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.QuickBetslip,
});

export const AsyncRestoreBetslipFromURL = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.RestoreBetslipFromURL,
});

export const AsyncSynchronizeBetslipState = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.SynchronizeBetslipState,
});

export const AsyncRestrictions = loadable(loadBetslipModule, {
    resolveComponent: betslipModule =>
        betslipModule.default.components.Restrictions,
});
